import { render } from "./ViewSettings.vue?vue&type=template&id=bcbd1656&scoped=true"
import script from "./ViewSettings.vue?vue&type=script&lang=js"
export * from "./ViewSettings.vue?vue&type=script&lang=js"

import "./ViewSettings.vue?vue&type=style&index=0&id=bcbd1656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcbd1656"]])

export default __exports__